import ActivityTab from "@/modules/lead-page/new/components/activity/activity-tab";
import { Track } from "../../types";
import { ActivityScrollProvider } from "@/modules/lead-page/new/context/activity-scroll-context";
import AddTrackComment from "../activity-tab/add-comment";
import { TrackCommentSource } from "../../dtos";
import { TrackConstructionProvider } from "../../contexts/track-construction.context";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";

export default function PropertyConstruction({ track }: { track: Track }) {
  return (
    <TrackConstructionProvider trackUId={track.uid}>
      <ActivityScrollProvider>
        <ActivityTab
          isHeaderCollapsed={false}
          addComment={
            <PermissionGuard
              permissions={[
                {
                  name: PermissionsEnum.ADD_CONSTRUCTION_UPDATE,
                  level: PermissionLevel.WRITE,
                },
              ]}
            >
              <AddTrackComment
                trackUId={track.uid}
                source={TrackCommentSource.construction}
              />
            </PermissionGuard>
          }
        />
      </ActivityScrollProvider>
    </TrackConstructionProvider>
  );
}
